<template>
  <el-tooltip :content="content" :disabled="!overflowing" placement="top" :open-delay="160">
    <span ref="text" class="overflow-text" v-bind="$attrs" v-on="$listeners" @mouseenter="measure" @focus="measure"><slot /></span>
  </el-tooltip>
</template>
<script>
export default {
  name: 'OverflowText',
  inheritAttrs: false,
  data: () => ({ overflowing: false, content: '' }),
  methods: {
    measure() {
      const el = this.$refs.text
      this.content = el.textContent.trim()
      this.overflowing = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
    }
  }
}
</script>
<style scoped>
.overflow-text { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
</style>
